module.exports = __webpack_public_path__ + "img/person_raising_hand.8dd67b13.gif";